export const ISSUE_ATTRIBUTE_NAMES = {
  ID: 'displayId',
  TITLE: 'title',
  DESCRIPTION: 'description',
  STATUS: 'status',
  ASSIGNED_TO: 'assignedTo',
  ASSIGNED_TO_TYPE: 'assignedToType',
  DUE_DATE: 'dueDate',
  LOCATION_ID: 'locationId',
  LOCATION_DETAILS: 'locationDetails',
  ISSUE_TYPE_ID: 'issueTypeId',
  ISSUE_SUB_TYPE_ID: 'issueSubtypeId',
  ISSUE_SUB_TYPE_ID_ACTIVITY: 'issueSubtypeId',
  CUSTOM_ATTRIBUTES: 'customAttributes',
  ROOT_CAUSE_ID: 'rootCauseId',
  OWNER_ID: 'ownerId',
  OFFICIAL_RESPONSE: 'officialResponse',
  COMMENT: 'comment',
  ATTACHMENTS_ATTRIBUTES: 'attachmentsAttributes',
  ATTACHMENT: 'attachment',
  COMMENT_BODY: 'body',
  DELETED_AT: 'deletedAt',
  LINKED_DOCUMENTS: 'linkedDocuments',
  TEMPLATE_ID: 'issueTemplateId',
  CONTAINER_ID: 'containerId',
  SNAPSHOT_URN: 'snapshotUrn',
  PERMITTED_ATTRIBUTES: 'permittedAttributes',
  PERMITTED_STATUSES: 'permittedStatuses',
  PERMITTED_ACTIONS: 'permittedActions',
  ISSUE_TEMPLATE_ID: 'issueTemplateId',
  COMMENT_COUNT: 'commentCount',
  ATTACHMENT_COUNT: 'attachmentCount',
  OPENED_BY: 'openedBy',
  OPENED_AT: 'openedAt',
  CLOSED_BY: 'closedBy',
  CLOSED_AT: 'closedAt',
  UPDATED_BY: 'updatedBy',
  UPDATED_AT: 'updatedAt',
  CREATED_BY: 'createdBy',
  CREATED_AT: 'createdAt',
  LINKS: 'links',
  PAGINATION: 'pagination'
};

const SPECIAL_SORTING_NAMES = {
  [ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID]: 'rootCause',
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_TYPE_ID]: 'issueType',
  [ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID]: 'issueSubType'
};

export const getSortName = attribute => SPECIAL_SORTING_NAMES[attribute] ?? attribute;
